import React, { useEffect } from "react";
import img2 from "../assets/indoor_air_quality.png";
import Footer from "../components/Footer";


const IndoorAirQualityMonitoringSystem = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="App">
            <div className="container py-5 main-content" style={{ marginTop: "50px" }}>
                <h1>Indoor Air Quality Monitoring System</h1>


                <p className="lead">
                    <strong>Indoor Air Quality Monitoring System</strong> continuously measures key environmental parameters such
                    as temperature, humidity, CO₂ levels, Ammonia, and particulate matter (PM2.5/PM10).
                    The data is transmitted to a secure cloud server for visualization and alerts, helping maintain healthy
                    indoor environments in offices, hospitals, and schools.
                    It assists facility teams in identifying ventilation inefficiencies and improving indoor comfort and energy
                    management.
                </p>

                <div className="row my-4">

                    <div className="col-md-12 mb-5 d-flex justify-content-center">
                        <div className="img-card h-100 d-flex align-items-center justify-content-center">
                            <img
                                src={img2}
                                alt="Indoor Air Quality Monitoring System Image"
                                className="img-fluid rounded shadow"
                                style={{ maxHeight: "400px", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                </div>

                <style>{`
                        .img-card {
                            background: #f8fafc;
                            border: 1px solid #e3e8ee;
                            border-radius: 16px;
                            padding: 24px;
                            box-shadow: 0 4px 24px rgba(25, 118, 210, 0.07);
                            transition: box-shadow 0.2s, transform 0.2s;
                            min-height: 260px;
                        }
                        .img-card:hover {
                            box-shadow: 0 8px 32px rgba(25, 118, 210, 0.15);
                            transform: translateY(-4px) scale(1.02);
                        }
                `}</style>
            </div>
            <Footer />
        </div>
    );
};

export default IndoorAirQualityMonitoringSystem;;
